import type { Form } from '../../../../common/types/form';
import type { Client } from '../../../../common/types/client';
import countryList from '../../../../common/countryList';

const anamnesisForm: Form<Client> = {
  key: 'anamnesis',
  title: 'Anamnese',
  fields: [
    {
      key: 'age',
      label: 'Alter der Frau',
      fieldTypes: 'select',
      options: [
        { label: 'bis 21 Jahre', value: 'upToTwentyOneYears' },
        { label: '22 - 30 Jahre', value: 'twentyTwoToThirtyYears' },
        { label: '31 - 40 Jahre', value: 'thirtyOneToFortyYears' },
        { label: '41 - 50 Jahre', value: 'fortyOneToFiftyYears' },
        { label: '51 - 60 Jahre', value: 'fiftyOneToSixtyYears' },
        { label: '61 - 70 Jahre', value: 'SixtyOneToSeventyYears' },
        { label: 'älter als 70 Jahre', value: 'olderThanSeventyYears' },
        { label: 'unbekannt', value: 'unknown' },
      ],
    },
    {
      key: 'origin',
      label: 'Migrationshintergrund',
      fieldTypes: 'select',
      options: [
        { label: 'mit Migrationshintergrund', value: 'withMigrationBackground' },
        { label: 'ohne Migrationshintergrund', value: 'withoutMigrationBackground' },
        { label: 'unbekannt', value: 'unknown' },
      ],
    },
    {
      key: 'nationality',
      label: 'Staatsangehörigkeit',
      fieldTypes: 'select',
      options: countryList,
    },
    {
      key: 'children',
      label: 'Minderjährige Kinder',
      fieldTypes: 'checkbox',
    },
    {
      key: 'directViolence',
      label: 'Direkt von Gewalt betroffene Kinder',
      fieldTypes: 'number',
      breakRowAfterField: true,
      isVisible: (client) => client.children === true,
    },
    {
      key: 'ageOfChildrenZeroToThreeYears',
      label: 'Kinder im Alter von 0 - 3 Jahre',
      fieldTypes: 'number',
      isVisible: (client) => client.children === true,
    },
    {
      key: 'ageOfChildrenFourToSixYears',
      label: 'Kinder im Alter von 4 - 6 Jahre',
      fieldTypes: 'number',
      isVisible: (client) => client.children === true,
    },
    {
      key: 'ageOfChildrenSevenToThirteenYears',
      label: 'Kinder im Alter von 7 - 13 Jahre',
      fieldTypes: 'number',
      isVisible: (client) => client.children === true,
    },
    {
      key: 'ageOfChildrenFourteenToSeventeenYears',
      label: 'Kinder im Alter von 14 - 17 Jahre',
      fieldTypes: 'number',
      isVisible: (client) => client.children === true,
    },
    {
      key: 'stabilizationGroup',
      label: 'Interesse Stabilisierungsgruppe',
      fieldTypes: 'checkbox',
      xsWidth: 6,
    },
    {
      key: 'traumaCounseling',
      label: 'Interesse an traumasensiblen Intensivangebot',
      fieldTypes: 'checkbox',
      xsWidth: 6,
    },
  ],
};

export default anamnesisForm;
